import alt from "../alt";

class CouponActions {
  constructor() {
    this.generateActions(
      "create",
      "delete",
      "updateCoupons",
      "fetchOne",
      "fetchUses",
      "fetchAllForBucket",
      "fetchFailed",
      "editFailed"
    );
  }

  updateCoupon(id, coupon) {
    return { id, coupon };
  }

  edit(id, values) {
    return { id, values };
  }
}

export default alt.createActions(CouponActions);



// WEBPACK FOOTER //
// ./src/app/actions/CouponActions.js